import React from 'react';

const Globe = (props: any) => {
  return (
        <svg
        // xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        // {...props}
        >
            <g fill="none" stroke="currentColor">
                <ellipse cx={12} cy={12.006} rx={3.095} ry={7.998} />
                <circle cx={12} cy={12} r={8} />
                <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 11.995l16 .01"
                />
            </g>
        </svg>
  )
}

export default Globe;